import React, { Component } from 'react';

import './tag.scss';

import { TagAPI } from '@philips-emr/tws-components-api';
import { Type } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { expression, oneOf } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { classNames, enumValues, isEnumValid } from '@philips-emr/tws-utils';

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: TagAPI })
class Tag extends Component {

  static propTypes = {
    /** The text content of the tag. */
    value: expression,

    /** The type of the tag,  */
    type: oneOf(enumValues(Type)),
  };

  static defaultProps = {
    text: '',
    type: Type.NEUTRAL,
  };

  render() {
    const { value, type } = this.props;

    if (!value || (value && !value.length)) {
      return null;
    }

    const rootClasses = {
      'c-tag': true,
      [`is-${type}`]: isEnumValid(Type, type),
    };

    return (
      <div className={classNames(rootClasses)} x-contrast="bg">
        <span className="c-tag__text">{msg(value)}</span>
      </div>
    );
  }
}

export default Tag;
